import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'wl-mass-comm-message-html-editor-dialog',
  templateUrl: './mass-comm-message-html-editor-dialog.component.html',
  styleUrls: ['./mass-comm-message-html-editor-dialog.component.less'],
    standalone: false
})
export class MassCommMessageHtmlEditorDialogComponent {
  @Output() messageTextToggled = new EventEmitter<boolean>();

  showModal: boolean = false;
  text: boolean = false;

  public open(text: boolean) {
    this.text = text;
    this.showModal = true;
  }

  public toggleMessageText() {
    this.messageTextToggled.emit();
    this.close();
  }

  public close() {
    this.showModal = false;
  }
}
